import React, { useEffect, useRef, useState } from 'react';
import { useLocation, Link, useNavigate, json} from 'react-router-dom';
import '../assets/css/custom.css';
import '../assets/css/font-awesome.css';
import '../assets/css/sweetalert.css';
import '../assets/css/bootstrap.min.css';
import '../assets/css/steps.css';
import '../assets/css/Resident.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleRight, faEdit, faIdBadge, faPlus, faSearch, faSort, faTrash } from '@fortawesome/free-solid-svg-icons';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import Menus from "./menus";
import ReactDOM from "react-dom";
// import { Wizard, Steps, Step, WithWizard } from "react-multistep-wizard";
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import { Stepper, Step, StepLabel } from '@mui/material';
import { Textarea } from '@material-tailwind/react';
import { Circle, FactCheck } from '@mui/icons-material';
import familyavatar from '../assets/img/family-avatar.png';
import familyavatar2 from '../assets/img/family-avatar-2.png';
import familyavatar3 from '../assets/img/family-avatar-3.png';
import familyavatar4 from '../assets/img/family-avatar-4.png';
import ResidentInital from '../assets/img/resident-management.png';
import ResidingTag from '../assets/img/ResidingTag.png';
import NoResiding from '../assets/img/noResident.png'; 
import approvaltick from '../assets/img/approval.png';
import { faCheckCircle } from '@fortawesome/fontawesome-free-solid';
import Familydetails from './Familydetails';
import { commonAPI } from "../services/CommonAPIService"
import { ErrorSource } from '../common/constants'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from "react-dropdown-select";
import SelectSearch from 'react-select-search';
// import {useLocation, } from 'react-router-dom'


function Resident() {
    const [activeStep, setActiveStep] = useState(0);
    const steps = ['Step 1', 'Step 2', 'Step 3'];
    const [show, setShow] = useState(false);
    const [DeleteShow, setDeleteShow] = useState(false);
    const [ErrorShow, setErrorShow] = useState(false);
    const [Loading, setLoading] = useState(false);
    const [ParentList, setParentList] = useState("");
    const [ParentUpdate, setParentUpdate] = useState("");
    const [ParentPending, setParentPending] = useState([]);
    const [UserName, setUserName] = useState("");
    const [FullName, setFullName] = useState("");
    const [MobileNumber, setMobileNumber] = useState("");
    const [EmailId, setEmailId] = useState("");
    const [ClientName, setClientName] = useState("");
    const [Role, setRole] = useState("");
    const [Gender, setGender] = useState("");
    const [TowerList, setTowerList] = useState("");
    const [TowerIdSelect, setTowerIdSelect] = useState([]);
    const [FlatList, setFlatList] = useState("");
    const [FlatIdSelect, setFlatIdSelect] = useState([]);
    const [FlatFull, setFlatFull] = useState(false);
    const [SpocName, setSpocName] = useState();
    const [selectedImageTwo, setSelectedImageTwo] = useState(null)
    const [selectedImageThree, setSelectedImageThree] = useState(null)
    const [selectedImageFour, setSelectedImageFour] = useState(null)
    const [FamilyGroupIdDelete, setFamilyGroupIdDelete] = useState("");
    const [ChildDeleteModal, setChildDeleteModal] = useState(false);
    const [ChildIsParent, setChildIsParent] = useState("");
    const [UserMappingId, setUserMappingId] = useState("");
    const [ToggleBtn, setToggleBtn] = useState("");
    const [CheckPosition, setCheckPosition] = useState("");
    const [showFamily, setShowFamily] = useState(false);
    const [NewFlatNumber, setNewFlatNumber] = useState("");
    const [OldFlatNumber, setOldFlatNumber] = useState("");
    const [NewTowerSelect, setNewTowerSelect] = useState("");
    const [NewFlatList, setNewFlatList] = useState("");
    const [NewFlatListShow, setNewFlatListShow] = useState("");
    const [ErrorMessage, setErrorMessage] = useState("");
    const [ErrorMessageHeader, setErrorMessageHeader] = useState("");
    const [ModalWarningShow, setModalWarningShow] = useState(false);
    const [TenantWarningShow, setTenantWarningShow] = useState(false);
    const [OwnerWarningShow, setOwnerWarningShow] = useState(false);
    const [InfoWarningShow, setInfoWarningShow] = useState(false);
    const [FamilyTransferShow, setFamilyTransferShow] = useState(false);
    const [OldTowerName, setOldTowerName] = useState("");
    const [OldFlatName, setOldFlatName] = useState("");
    const [NoResidentData, setNoResidentData] = useState(false);
    const [NoTableData, setNoTableData] = useState(false);
    const [PendingTable, setPendingTable] = useState(false);
    const [VehiclePendingList, setVehiclePendingList] = useState("");
    const [NoVehicleTableData, setNoVehicleTableData] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();


    const data = location.state
    console.log("TowerIdSelect", TowerIdSelect, FlatIdSelect);
    console.log("data", location)
    console.log("NewFlatNumber", NewFlatNumber, NewTowerSelect);

    console.log("flat list data", FlatList, FlatIdSelect);

    const openCreateModal = () => {
        if (!TowerIdSelect[0]) {
            toast.warning("Please select Tower");
        } else if (!FlatIdSelect[0]) {
            toast.warning("Please select Flat");
        } else {
            if (FlatFull === true) {
                // toast.warning("Family is already Residing");
                setModalWarningShow(true);
                setTenantWarningShow(false);
                setOwnerWarningShow(false);
                setInfoWarningShow(true);
            } else {
                setShow(true)
                setUserName("")
                setMobileNumber("")
                setEmailId("")
                setRole("")
                setGender("")

            }
        }
    };

    const GetTowerList = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        try {
            setLoading(true);
            const endPointVariableKey = {
                urlVariable: null,
                buildingId: myUserData?.buildingId

            }
            setLoading(true);
            let response = await commonAPI("Tower", undefined, endPointVariableKey)
            if (response?.success === true) {
                setTowerList(response?.data);
                console.log("TowerList", response?.data);
                setLoading(false);
            } else {
                toast.error("Something went wrong");
                setLoading(false);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/Master/Tower/",
                "errorNumber": "GT01",
                "errorSource": "CuroNextPortal",
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Resident.js",
                "functionName": "GetTowerList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response.success == true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }

    }

    const GetFlatList = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        try {
            setLoading(true);
            const endPointVariableKey = {
                urlVariable: null,
                buildingId: myUserData?.buildingId

            }
            let response = await commonAPI("Flat", undefined, endPointVariableKey);
            if (response?.success === true) {
                setNewFlatList(response?.data)
                const tempData = response?.data.filter((item) => item?.towerId == TowerIdSelect[0])
                setFlatList(tempData);
                setLoading(false);
            } else {
                toast.error("Something went wrong");
                setLoading(false);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/Master/Flat",
                "errorNumber": "GF01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "Resident.js",
                "functionName": "getFlatList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }

    }

    const GetParentList = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodyData = {
            "buildingId": myUserData?.buildingId,
            "towerId": parseInt(TowerIdSelect[0]),
            "flatId": parseInt(FlatIdSelect[0]),
            // "isParent": true,
            "userImageRequired": true,
            // "buildingLogoRequired": false
        }

        try {
            console.log("Parent Table body", bodyData)
            let responseCheck = await commonAPI("GetCuroNextUserMapping", bodyData)
            setLoading(true);
            console.log("Parent Table", responseCheck?.data)

            if(responseCheck.success == true && responseCheck.message.length == 0) {
                const parentsOnly = responseCheck?.data?.filter(item => item.isParent === true) || [];

                setParentList(parentsOnly);
                setParentUpdate(parentsOnly);
                setParentPending(responseCheck?.data);
                const response = responseCheck;
                // const CheckData = response?.data.filter((item) => item?.currentStatus.toUpperCase() == "PENDING"  || item?.currentStatus.toUpperCase() == "APPROVED")
                // console.log("CheckData", CheckData)
                // if(CheckData[0]){
                    setPendingTable(true)
                // }else{
                //     setPendingTable(false)
                // }
                const CheckIsParent = response?.data.filter((item) => item?.isParent == true)
                console.log("CheckOwnerResiding", CheckIsParent)
                if(CheckIsParent[0]){
                    setNoResidentData(false)
                }else{
                    setNoResidentData(true)
                }
                const CheckPendingData = response?.data.filter((item) => item?.currentStatus.toUpperCase() == "PENDING"  )
                if(CheckPendingData[0]){
                    setNoTableData(false)
                }else{
                    setNoTableData(true)
                }
                const CheckOwnerResiding = response?.data.filter((item) => item?.roleName.toUpperCase() == "OWNER" && item?.isResiding == true)
                console.log("CheckOwnerResiding", CheckOwnerResiding)
                const CheckOwnerNotResiding = response?.data.filter((item) => item?.roleName.toUpperCase() == "OWNER" && item?.isResiding == false)
                console.log("CheckOwnerNotResiding", CheckOwnerNotResiding)
                const CheckTenantResiding = response?.data.filter((item) => item?.roleName.toUpperCase() == "TENANT" && item?.isResiding == true)
                console.log("CheckTenantResiding", CheckTenantResiding)

                if (CheckOwnerResiding[0]) {
                    // if there is any other family already residing in the flat
                    setFlatFull(true);
                } else if (CheckOwnerNotResiding[0] && CheckTenantResiding[0]) {
                    setFlatFull(true);
                } else {
                    setFlatFull(false);
                }
                
                setLoading(false);
            } else {
                toast.error("Something went wrong");
                setLoading(false);
            }
            // }
            // else  {

            // }  

        } catch (error) {
            console.log(error);
            setLoading(false);
            const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/User/CuroNextUserFamily",
                "errorNumber": "GP01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Resident.js",
                "functionName": "GetParentList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response.success == true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }

    }

    const GetPendingVehicleList = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodyData = { 
            "flatId":  FlatIdSelect[0],
            "currentStatus": "PENDING",
        };
        try {
            setLoading(true);
            const endPointVariableKey = {
                // urlVariable:`${"PENDING"}/${FlatIdSelect[0]}`,
                buildingId: myUserData?.buildingId
            }
            // let response = await commonAPI("PendingResVehicle", undefined, endPointVariableKey)
            let response = await commonAPI("GetResidentVehicle", bodyData, endPointVariableKey)
            // console.log("Notice List", response?.data)
            if (response?.success === true){
                console.log("VehicleList====================", response)
                setVehiclePendingList(response?.data);
                if(response?.data?.length == 0){
                    setNoVehicleTableData(true)
                }else{
                    setNoVehicleTableData(false)
                }
                setLoading(false);
            }else{
                setLoading(false);
                toast.error("Something went wrong");
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = { 
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber, // Need to be change
                "requestJSON": "",
                "uri": "/api/Master/Notice",
                "errorNumber": "PV01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "Resident.js",
                "functionName": "GetPendingVehicleList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError)
           
            if(response?.success === true && response?.message?.length == null){
                toast.error("Something went wrong");
                setLoading(false); 
            }else{
                toast.error("Something went wrong");
                setLoading(false); 
            }
        }

    }

    useEffect(() => {
        if(FlatIdSelect[0]){
            GetPendingVehicleList();
        }
    }, [FlatIdSelect])

    useEffect(() => {
        if(FlatIdSelect[0]){
            GetParentList();
            // GetParentListUpdated();
        }
    }, [FlatIdSelect])

    const GetParentListUpdated = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodyData = {
            "buildingId": myUserData?.buildingId,
            "towerId": TowerIdSelect,
            "flatId": FlatIdSelect,
            // "isParent": true,
            "userImageRequired": true,
            // "buildingLogoRequired": false
        }

        try {
            let response = await commonAPI("GetCuroNextUserMapping", bodyData)
            setLoading(true);


            if (response?.success == true) {
                console.log("Parent Table Updated", response)
                // setParentList(response?.data);
                const tempData = response?.data?.filter((item) => item?.flatId == FlatIdSelect[0])
                console.log("tempData flat Updated", tempData)
                // setParentUpdate(response?.data);
                if (response?.data.length == 2) {
                    setFlatFull(true)
                } else if (tempData.length == 0) {
                    setFlatFull(false)
                }
                setLoading(false);
            } else {
                toast.error("Something went wrong");
                setLoading(false);
            }
            // }
            // else  {

            // }  

        } catch (error) {
            console.log(error);
            setLoading(false);
            const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/User/CuroNextUserFamily",
                "errorNumber": "GP01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Resident.js",
                "functionName": "GetParentList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response.success == true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }

    }

    const SelectResiding = async (item) => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodyData = {
            "familyGroupId": item?.familyGroupId,
            "flatId": item?.flatId,
            "isResiding": item?.isResiding == true ? false : true,
            "modifiedUserId": myUserData?.userId?.toString()
        };
        try {
            setLoading(true);
            console.log("body", bodyData);
            let response = await commonAPI("ResetResiding", bodyData)
            console.log("ResetResiding", response);
            if (response.success == true && response.message.length == 0) {
                toast.success("Residing Resident Changed");
                setLoading(false);
                GetParentList();
                if (item?.isResiding == true) {
                    setFlatFull(false)
                } else {
                    setFlatFull(true)
                }

            } else {
                setLoading(false);
                if (response?.message[0].split("WARNING-")) {
                    const ErrorLogMessageHeader = response?.message[0].split("-")
                    const ErrorLogMessage = response?.message[0].split("WARNING-")
                    const ErrorMessage = ErrorLogMessage[1].split(".")
                    console.log("ErrorMessage", ErrorLogMessageHeader)
                    setErrorMessageHeader(ErrorLogMessageHeader[0])
                    setErrorMessage(ErrorMessage);
                    setErrorShow(true)
                } else if (response?.message[0].split("EXCEPTION-")) {
                    const ErrorLogMessageHeader = response?.message[0].split("-")
                    const ErrorLogMessage = response?.message[0].split("EXCEPTION-")
                    const ErrorMessage = ErrorLogMessage[1].split(".")
                    console.log("ErrorMessage", ErrorLogMessageHeader)
                    setErrorMessageHeader(ErrorLogMessageHeader[0])
                    setErrorMessage(ErrorMessage);
                    setErrorShow(true)
                } else if (response?.message[0].split("INFO-")) {
                    const ErrorLogMessageHeader = response?.message[0].split("-")
                    const ErrorLogMessage = response?.message[0].split("INFO-")
                    const ErrorMessage = ErrorLogMessage[1].split(".")
                    console.log("ErrorMessage", ErrorLogMessageHeader)
                    setErrorMessageHeader(ErrorLogMessageHeader[0])
                    setErrorMessage(ErrorMessage);
                    setErrorShow(true)
                } else {
                    toast.error(response.message[0]);
                }

            }


        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": bodyData,
                "uri": "/api/User/ResetResiding",
                "errorNumber": "PU01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Resident.js",
                "functionName": "SelectResiding",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response.success == true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }



    }

    const DeleteUserModal = (item) => {
        console.log("item", item);
        setChildDeleteModal(true)
        setUserMappingId(item?.userMappingId)
        setFamilyGroupIdDelete(item?.familyGroupId);
        setChildIsParent(item?.isParent)
        setCheckPosition(item?.roleName)
    }

    const DeleteChildUser = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodydata = {
            "modifiedUserId": myUserData?.userId?.toString(),
            "familyGroupId": FamilyGroupIdDelete,
            "userMappingId": null,
            "isParent": null
        };
        try {
            setLoading(true);
            console.log("body", bodydata);
            let response = await commonAPI("DeleteUserOrFamily", bodydata)
            setLoading(true);
            console.log("responsebody", response);
            if (response.success == true && response.message.length == 0) {
                toast.success(`${CheckPosition} Deleted`);
                setChildDeleteModal(false);
                setLoading(false);
                GetParentList();
                if (CheckPosition.toUpperCase() == "TENANT") {
                    setFlatFull(false)
                }

                const CheckOwnerNotResiding = ParentList.filter((item) => item?.roleName.toUpperCase() == "OWNER" && item?.isResiding == false)
                if(CheckOwnerNotResiding[0]){
                    setFlatFull(false);
                }
            } else {
                toast.error(response.message[0]);
                setLoading(false);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": bodydata,
                "uri": "/api/User/DeleteUserOrFamily",
                "errorNumber": "DC01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Resident.js",
                "functionName": "DeleteChildUser",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response.success == true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }



    }

    const FamilyTransferModal = (item) => {
        console.log("item", item);
        setShowFamily(true);
        setFamilyGroupIdDelete(item?.familyGroupId);
        setOldFlatNumber(item?.flatId);
        setNewFlatNumber("");
        setNewTowerSelect("")
        setOldTowerName(item?.towerName)
        setOldFlatName(item?.flatName)
    }

    const SubmitFamilyTransferModal = () => {
        if (!NewTowerSelect) {
            toast.warning("Please select Tower");
            setLoading(false);
        }else if (NewTowerSelect?.length == 1) {
            toast.warning("Please select Tower");
            setLoading(false); 
        }else if (!NewFlatNumber) {
            toast.warning("Please select New Flat Number");
            setLoading(false);
        }else if (NewFlatNumber?.length == 1){
            toast.warning("Please select New Flat Number");
            setLoading(false);
        }else{    
            setFamilyTransferShow(true)
            // set
        }
    }


    const FamilyTransferApi = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodydata = {
            "familyGroupId": FamilyGroupIdDelete,
            "flatId": OldFlatNumber,
            "newFlatId": NewFlatNumber[0],
            "modifiedUserId": myUserData?.userId?.toString()
        };
        try {
            const endPointVariableKey = {
                buildingId: myUserData?.buildingId
            }
            setLoading(true);
            console.log("body", bodydata);
            if (!NewTowerSelect ) {
                toast.warning("Please select Tower");
                setLoading(false);
            }else if (NewTowerSelect?.length == 1) {
                toast.warning("Please select Tower");
                setLoading(false);    
            }else if (!NewFlatNumber) {
                toast.warning("Please select New Flat Number");
                setLoading(false);
            }else if (NewFlatNumber?.length == 1){
                toast.warning("Please select New Flat Number");
                setLoading(false);
            } else {    
                let response = await commonAPI("FamilyTransfer", bodydata, endPointVariableKey)
                setLoading(true);
                console.log("responsebody", response);
                if (response?.success == true && response?.message?.length == 0) {
                    toast.success(`Family Transferred`);
                    setShowFamily(false);
                    setFamilyTransferShow(false);
                    setLoading(false);
                    setFamilyGroupIdDelete("");
                    setNewFlatNumber("");
                    GetParentList();
                    setNewTowerSelect("")
                } else {
                    setLoading(false);
                    if (response?.message[0].split("WARNING-")) {
                        const ErrorLogMessageHeader = response?.message[0].split("-")
                        const ErrorLogMessage = response?.message[0].split("WARNING-")
                        const ErrorMessage = ErrorLogMessage[1].split(".")
                        console.log("ErrorMessage", ErrorLogMessageHeader)
                        setErrorMessageHeader(ErrorLogMessageHeader[0])
                        setErrorMessage(ErrorMessage);
                        setErrorShow(true)
                    } else if (response?.message[0].split("EXCEPTION-")) {
                        const ErrorLogMessageHeader = response?.message[0].split("-")
                        const ErrorLogMessage = response?.message[0].split("EXCEPTION-")
                        const ErrorMessage = ErrorLogMessage[1].split(".")
                        console.log("ErrorMessage", ErrorLogMessageHeader)
                        setErrorMessageHeader(ErrorLogMessageHeader[0])
                        setErrorMessage(ErrorMessage);
                        setErrorShow(true)
                    } else if (response?.message[0].split("INFO-")) {
                        const ErrorLogMessageHeader = response?.message[0].split("-")
                        const ErrorLogMessage = response?.message[0].split("INFO-")
                        const ErrorMessage = ErrorLogMessage[1].split(".")
                        console.log("ErrorMessage", ErrorLogMessageHeader)
                        setErrorMessageHeader(ErrorLogMessageHeader[0])
                        setErrorMessage(ErrorMessage);
                        setErrorShow(true)
                    } else {
                        toast.error(response.message[0]);
                    }
                    // toast.error(response.message[0]);

                }
            }


        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": bodydata,
                "uri": "/api/User/DeleteUserOrFamily",
                "errorNumber": "DC01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Resident.js",
                "functionName": "DeleteChildUser",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response.success == true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }



    }

    useEffect(() => {
        GetTowerList();
        // GetParentList();
        // GetFlatList();
    }, [])

    // useEffect(() => {
    //     // if(TowerIdSelect.length > 0){
    //         GetParentList();
    //     // }    
    // }, [TowerIdSelect, FlatIdSelect])

    useEffect(() => {
        if (!TowerIdSelect[0]) {
            setParentUpdate("")
            // setFlatIdSelect([])
            // setTowerIdSelect("")
            // setFlatList("")
            // console.log("it is run again");
            setLoading(false);
            return;
        }else{
            setParentUpdate("")
            // setFlatIdSelect("")
        }

        
        // if (TowerIdSelect) {
        //     const tempData = ParentList.filter((item) => item?.towerId == TowerIdSelect[0])
        //     console.log("tempData tower", tempData)
        //     // setParentUpdate(tempData);
        //     setParentUpdate("")
        //     setFlatIdSelect([])
        //     // setTowerIdSelect("")
        //     setLoading(false);
        // } else {
        //     console.log("it is run 2");
        //     // setParentUpdate(ParentList);
        //     setParentUpdate("")
        //     // setTowerIdSelect("")
        //     setFlatIdSelect([])
        //     setLoading(false);
        // }
    }, [TowerIdSelect])

    useEffect(() => {
        if (!FlatIdSelect[0]) {
            setParentUpdate("")
            setNoResidentData(false)
            setPendingTable(false)
            setLoading(false);
            return;

        }
        if(ParentList.length != 0){
            setPendingTable(true)
            if (FlatIdSelect) {
                const tempData = ParentList?.filter((item) => item?.flatId == FlatIdSelect[0])
                console.log("tempData flat@@@@@@@@@@@@@@@@@@@@@@@", tempData)
                setParentUpdate(ParentList);
                const CheckIsParent = ParentList?.filter((item) => item?.isParent == true)
                console.log("CheckOwnerResiding", CheckIsParent)
                if(CheckIsParent[0]){
                    setNoResidentData(false)
                }else{
                    setNoResidentData(true)
                }
                const CheckPendingData = ParentList?.filter((item) => item?.currentStatus.toUpperCase() == "PENDING"  )
                if(CheckPendingData[0]){
                    setNoTableData(false)
                }else{
                    setNoTableData(true)
                }
                const CheckOwnerResiding = ParentList.filter((item) => item?.roleName.toUpperCase() == "OWNER" && item?.isResiding == true)
                console.log("CheckOwnerResiding", CheckOwnerResiding)
                const CheckOwnerNotResiding = ParentList.filter((item) => item?.roleName.toUpperCase() == "OWNER" && item?.isResiding == false)
                console.log("CheckOwnerNotResiding", CheckOwnerNotResiding)
                const CheckTenantResiding = ParentList.filter((item) => item?.roleName.toUpperCase() == "TENANT" && item?.isResiding == true)
                console.log("CheckTenantResiding", CheckTenantResiding)

                if (CheckOwnerResiding[0]) {
                    // if there is any other family already residing in the flat
                    setFlatFull(true);
                    setNoResidentData(false)
                } else if (CheckOwnerNotResiding[0] && CheckTenantResiding[0]) {
                    setFlatFull(true);
                    setNoResidentData(true)
                    setNoResidentData(false)
                } else {
                    setFlatFull(false);
                    setNoResidentData(true)
                }
                setLoading(false);
            } else {
                console.log("it is run 2");
                // setParentUpdate(ParentList);
                setLoading(false);
            }
        }    
    }, [FlatIdSelect[0]])

    useEffect(() => {
        if (TowerIdSelect) {
            GetFlatList();
        }
    }, [TowerIdSelect])

    useEffect(() => {
        if (NewTowerSelect) {
            const tempData = NewFlatList.filter((item) => item.towerId == NewTowerSelect[0])
            setNewFlatListShow(tempData);
            setNewFlatNumber("")
            console.log("setNewFlatListShow", tempData, NewTowerSelect[0])
        }else if(NewTowerSelect.length == 0){
            setNewFlatListShow("");
            setNewFlatNumber("")
        }
    }, [NewTowerSelect])

    const ResidentUser = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodydata = {
            "createdUserId": myUserData?.userId?.toString(),
            "userName": UserName,
            "mobileNumber": MobileNumber,
            "termsAccepted": true,
            // "productAccessFactor": myUserData?.productAccessFactor,
            "emailId": EmailId,
        };
        const CheckResiding = ParentUpdate.filter((item) => item?.isResiding == true)
        console.log("CheckResiding", CheckResiding)
        const CheckOwnerResiding = ParentUpdate.filter((item) => item?.roleName.toUpperCase() == "OWNER" && item?.isResiding == true)
        console.log("CheckOwnerResiding", CheckOwnerResiding)
        const CheckOwnerNotResiding = ParentUpdate.filter((item) => item?.roleName.toUpperCase() == "OWNER" && item?.isResiding == false)
        console.log("CheckOwnerNotResiding", CheckOwnerNotResiding)
        const CheckTenantResiding = ParentUpdate.filter((item) => item?.roleName.toUpperCase() == "TENANT" && item?.isResiding == true)
        console.log("CheckTenantResiding", CheckTenantResiding)
        const CheckOwner = ParentUpdate.filter((item) => item?.roleName.toUpperCase() == "OWNER")
        console.log("CheckOwner", CheckOwner)
        try {
            if (!UserName) {
                toast.warning("Please enter Name");
                setLoading(false);
            } else if (!MobileNumber) {
                toast.warning("Please enter Mobile Number");
                setLoading(false);
            }
            else if (MobileNumber.length != 10) {
                toast.warning("Please enter Valid Mobile Number");
                setLoading(false);
            }
            else if (!Role) {
                toast.warning("Please select Role");
                setLoading(false);
            }else if(!Gender) {
                toast.warning("Please select Gender");
                setLoading(false);
            } else if (CheckOwner[0]?.roleName == Role) {
                // toast.warning("This flat owner is already exists");
                setModalWarningShow(true);
                setTenantWarningShow(false);
                setOwnerWarningShow(true);
                setInfoWarningShow(false);
                setLoading(false);
            } else if (CheckOwnerResiding[0]?.roleName == Role) {
                // toast.warning("Tenant is already residing");
                setModalWarningShow(true);
                setTenantWarningShow(true);
                setOwnerWarningShow(false);
                setInfoWarningShow(false);
                setLoading(false);
            } else if (CheckTenantResiding[0]?.roleName == Role) {
                // toast.warning("Tenant is already residing");
                setModalWarningShow(true);
                setTenantWarningShow(true);
                setOwnerWarningShow(false);
                setInfoWarningShow(false);
                setLoading(false);
            } else {
                console.log("body", bodydata);
                setLoading(true);
                const endPointVariableKey = {
                    urlVariable: MobileNumber,
                }
                let responseLogin = await commonAPI("LoginGet", undefined, endPointVariableKey)
                console.log("responseLogin", responseLogin);
                // if(responseLogin.success == true && responseLogin.message.length == 0){
                if (responseLogin.message.length == 0) {
                    const bodyUserMapping = {
                        "createdUserId": myUserData?.userId.toString(),
                        "userId": responseLogin?.data?.userId,
                        "buildingId": myUserData?.buildingId,
                        "buildingName": myUserData?.buildingName,
                        "towerId": TowerIdSelect[0],
                        "towerName": TowerIdSelect[1],
                        "flatId": FlatIdSelect[0],
                        "flatName": FlatIdSelect[1],
                        "roleName": Role,
                        "gender": Gender,
                        "isParent": false,
                        "currentStatus": "APPROVED",
                        "approverComment": null,
                        "approverUserName": myUserData?.userName,
                        "approvalDt": toISTISOString(new Date()),
                        "loggedInUserRole": myUserData?.roleName,
                        "loggedInUserName": myUserData?.userName
                    };
                    console.log("body", bodyUserMapping);
                    let responseMapping = await commonAPI("CuroNextUserMappingAdd", bodyUserMapping)
                    console.log("responseMapping", responseMapping);
                    if (responseMapping.success == true && responseMapping.message.length == 0) {
                        toast.success("Primary Resident Added");
                        setShow(false);
                        setLoading(false);
                        if (Role == "Owner") {
                            setFlatFull(true);
                        }
                        GetParentList();
                    } else {
                        toast.error(responseLogin.message[0]);
                        setLoading(false);
                    }
                } else {
                    if (!UserName) {
                        toast.warning("Please enter Name");
                        setLoading(false);
                    } else if (!MobileNumber) {
                        toast.warning("Please enter Mobile Number");
                        setLoading(false);
                    }
                    else if (MobileNumber.length != 10) {
                        toast.warning("Please enter Valid Mobile Number");
                        setLoading(false);
                    }
                    else if (!Role) {
                        toast.warning("Please select Role");
                        setLoading(false);
                    } else if (CheckOwner[0]?.roleName == Role) {
                        toast.warning("This flat owner is already exists");
                        setLoading(false);
                    } else if (CheckOwnerResiding[0]?.roleName == Role) {
                        toast.warning("Tenant is already residing");
                        setLoading(false);
                    } else if (CheckTenantResiding[0]?.roleName == Role) {
                        toast.warning("Tenant is already residing");
                        setLoading(false);
                    } else {
                        let response = await commonAPI("User", bodydata)
                        console.log("responsebody", response);

                        if (response?.success == true && response?.message.length == 0) {
                            const bodyUserMapping = {
                                "createdUserId": myUserData?.userId.toString(),
                                "userId": response?.data?.userId,
                                "buildingId": myUserData?.buildingId,
                                "buildingName": myUserData?.buildingName,
                                "towerId": TowerIdSelect[0],
                                "towerName": TowerIdSelect[1],
                                "flatId": FlatIdSelect[0],
                                "flatName": FlatIdSelect[1],
                                "roleName": Role,
                                "gender": Gender,
                                "isParent": true,
                                "currentStatus": "APPROVED",
                                "approverComment": null,
                                "approverUserName": myUserData?.userName,
                                "approvalDt": toISTISOString(new Date()),
                                "loggedInUserRole": myUserData?.roleName,
                                "loggedInUserName": myUserData?.userName
                            };
                            console.log("body", bodyUserMapping);
                            let responseMapping = await commonAPI("CuroNextUserMappingAdd", bodyUserMapping)
                            console.log("responseMapping", responseMapping);
                            if (responseMapping.success == true && responseMapping.message.length == 0) {
                                toast.success("Primary Resident Added");
                                setShow(false);
                                setLoading(false);
                                if (Role == "Owner") {
                                    setFlatFull(true);
                                }
                                GetParentList();
                            } else {
                                toast.error(response.message[0]);
                                setLoading(false);
                            }

                        } else {
                            toast.error(response.message[0]);
                            setLoading(false);
                        }
                    }
                }
                // }


            }
        } catch (error) {
            console.log(error);
            setLoading(false);
            const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/User/User",
                "errorNumber": "RU01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Resident.js",
                "functionName": "ResidentUser",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response.success == true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }



    }
    const handleFileInputChangeTwo = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setSelectedImageTwo(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };
    const handleFileInputChangeThree = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setSelectedImageThree(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };
    const handleFileInputChangeFour = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setSelectedImageFour(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };
    const handleNext = () => {
        setActiveStep((prevActiveStep) => {
            if (prevActiveStep >= steps.length - 1) { // Assuming 'steps' is your array of step labels
                return 0; // Reset to first step
            } else {
                // console.log(inpRef.current.value)
                return prevActiveStep + 1;

            }
        });
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    

    function toISTISOString(date) {
        // Get the current time in milliseconds since the Unix Epoch
        const currentTime = date.getTime();

        // IST offset is +5:30 (19800 seconds)
        const istOffset = 19800 * 1000; // Convert seconds to milliseconds

        // Create a new Date object with the adjusted time
        const istDate = new Date(currentTime + istOffset);

        // Format the date parts
        const pad = (num) => String(num).padStart(2, '0');
        const year = istDate.getUTCFullYear();
        const month = pad(istDate.getUTCMonth() + 1); // getUTCMonth is zero-indexed
        const day = pad(istDate.getUTCDate());
        const hours = pad(istDate.getUTCHours());
        const minutes = pad(istDate.getUTCMinutes());
        const seconds = pad(istDate.getUTCSeconds());
        const milliseconds = String((istDate.getUTCMilliseconds() / 1000).toFixed(3)).slice(2, 5);

        // Construct the ISO string with the GMT+5:30 offset
        const istIsoString = `${year}-${month}-${day}T${hours}:${minutes}`;

        return istIsoString;
    }

    const handleViewMore = () => {
      console.log("it is pressed")
      setLoading(true)
      window.sessionStorage.setItem("FlatnTower", JSON.stringify({ flatId: FlatIdSelect, towerId: TowerIdSelect}));
      setLoading(false)
    }
    
    // retrieving the value stored in the session storage to show in page
    useEffect(() => {
        const value = window.sessionStorage.getItem("FlatnTower");
        if(value){
            const parsedValue = JSON.parse(value);
            // setTowerIdSelect({
            //     id: parseInt(parsedValue.towerId[0]),
            //     name: parsedValue.towerId[1]
            // });
            setTowerIdSelect(parsedValue?.towerId);
            setFlatIdSelect(parsedValue?.flatId);
            console.log("stored data", {
                towerId: parsedValue?.towerId,
                flatId: parsedValue?.flatId
            })
        }
    }, [])

    // useEffect(() => {
    //     console.log("it is run");
    //     const handleBeforeUnload = (event) => {
    //         // Check if the new location is not home
    //         if (location.pathname !== "/Familydetails") {
    //             // Clear session storage
    //             sessionStorage.removeItem("FlatnTower");
    //         }
    //     };

    //     window.addEventListener('beforeunload', handleBeforeUnload);

    //     return () => {
    //         window.removeEventListener('beforeunload', handleBeforeUnload);
    //     };
    // }, [location]);

    // useEffect(() => {
    //     const unlisten = navigate((location) => {
    //         if (location.pathname !== "/Familydetails") {
    //             sessionStorage.removeItem("FlatnTower");
    //         }
    //     });

    //     return () => {
    //         unlisten();
    //     };
    // }, [navigate]);

    const towerOptions = TowerList
    ? TowerList.map(item => ({
        value: item.towerId,
        label: item.towerName ? String(item.towerName) : 'Unnamed',
      }))
    : [];

  const flatOptions = FlatList
    ? FlatList.map(item => ({
        value: item.flatId,
        label: item.flatName ? String(item.flatName) : 'Unnamed',
      }))
    : [];
    
    return (
        <>
            {Loading ?
                <div className="loaderDiv">
                    <div className="loader"></div>
                </div>
                : null}
            <Menus />
            <ToastContainer />
            
            <section id="client-builder">
                <div className="container-fluid pt-2" style={{ paddingTop: "95px !important" }}>

                    <div className="row mt-5 pt-2" style={{ alignItem: 'center' }}>
                        <div className="col-lg-4 col-md-4">
                            <div className="HeadingTop">
                                <h3>  Manage Residents  </h3>
                                <span> Maintain a centralized database of all residents.</span>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-8 px-0  text-right" style={{ alignContent: 'center' }}>
                            <div className='srcbtn' style={{ marginRight: "64px" }}>
                                 {/* <select size="md" className="sltareamodal col-6 ml-auto bg-white" value={TowerIdSelect} onChange={(e) => {
                                    console.log("selection", e.target.value)
                                    setTowerIdSelect(e.target.value.split(","));
                                    setFlatIdSelect([]);
                                }}>
                                    <option value={[]}>Select Tower</option>
                                    {TowerList ? TowerList.map((item, index) => <option key={index} value={[item?.towerId, item?.towerName]}>{item.towerName}</option>) : null}
                                </select> */}
                                {/* <select size="md" className="sltareamodal col-6 ml-auto bg-white" value={TowerIdSelect} onChange={(e) => {
                                    console.log("selection", e.target.value)
                                    setTowerIdSelect(e.target.value.split(","));
                                    setFlatIdSelect([]);
                                }}>
                                    <option value={[]}>Select Tower</option>
                                    {TowerList ? TowerList.map((item, index) => <option key={index} value={[item?.towerId, item?.towerName]}>{item.towerName}</option>) : null}
                                </select>
                                <select size="md" className="sltareamodal col-6 ml-auto bg-white" value={FlatIdSelect} onChange={(e) => {
                                    console.log("selection", e.target.value)
                                    setFlatIdSelect(e.target.value.split(","));
                                }}>
                                    <option value={[]}>Select Flat</option>
                                    {FlatList  ? FlatList.map((item, index) => <option key={index} value={[item?.flatId, item?.flatName]}>{item.flatName}</option>) : null}
                                </select> */}
                                {/* <Select
                                    options={TowerList ? TowerList.map(item => ({ id: item.towerId, name: item.towerName })) : []}
                                    labelField="name"
                                    className="sltareamodal"
                                    valueField="id"
                                    placeholder='Select Tower'
                                    values={
                                        TowerList && TowerIdSelect && TowerIdSelect.length > 0
                                            ? TowerList.filter(item => item.towerId === TowerIdSelect[0]).map(item => ({ id: item.towerId, name: item.towerName }))
                                            : []
                                    }
                                    onChange={(values) => {
                                        if (values && values.length > 0) {
                                            setTowerIdSelect([parseInt(values[0].id), values[0].name]);
                                            console.log("values", values)
                                        } else {
                                            setTowerIdSelect([]);
                                        }
                                        // setFlatIdSelect([]);
                                    }}
                                    style={{
                                        fontSize: '13px',
                                        borderColor: '#ccc',
                                        borderRadius: '4px',
                                        height: '30px',
                                        width: '150px',
                                        backgroundColor: 'gainsboro',
                                        textAlign: 'left',
                                    }}
                                    dropdownStyle={{
                                        width: '200px',
                                    }}
                                /> */}
                                      {/* <Select
                                        isSearchable={true}
                                        options={towerOptions}
                                        getOptionLabel={(option) => option.label}
                                        getOptionValue={(option) => option.value}
                                        className=""
                                        placeholder="Select Tower"
                                        values={
                                        TowerIdSelect && TowerIdSelect.length > 0
                                            ? towerOptions.filter(option => option.value === TowerIdSelect[0])
                                            : []
                                        }
                                        onChange={(selectedOptions) => {
                                        if (selectedOptions && selectedOptions.length > 0) {
                                            setTowerIdSelect([selectedOptions[0].value, selectedOptions[0].label]);
                                        } else {
                                            setTowerIdSelect([]);
                                        }
                                        setFlatIdSelect([]);
                                        setFlatList([]);
                                        
                                        }}
                                        filterOption={(option, inputValue) =>
                                        option.label.toLowerCase().includes(inputValue.toLowerCase())
                                        }
                                        style={{
                                        fontSize: '13px',
                                        borderColor: '#ccc',
                                        borderRadius: '4px',
                                        height: '36px',
                                        width: '150px',
                                        backgroundColor: '#fff',
                                        textAlign: 'left',
                                        marginRight: 10
                                        }}
                                        dropdownStyle={{
                                        width: '200px',
                                        }}
                                    /> */}
                                 <Select
                                    searchable={true}
                                    clearable={TowerIdSelect && TowerIdSelect.length > 0}
                                    options={towerOptions}
                                    labelField="label"
                                    valueField="value"
                                    className=""
                                    placeholder="Select Tower"
                                    values={
                                        TowerIdSelect && TowerIdSelect.length > 0
                                            ? towerOptions.filter(option => option.value === TowerIdSelect[0])
                                            : []
                                    }
                                    onChange={(selectedOptions) => {
                                        if (selectedOptions && selectedOptions.length > 0) {
                                            setTowerIdSelect([selectedOptions[0].value, selectedOptions[0].label]);
                                        } else {
                                            setTowerIdSelect([]);
                                        }
                                        setFlatIdSelect([]);
                                        setFlatList([]);
                                    }}
                                    searchBy="label"
                                    style={{
                                        fontSize: '13px',
                                        borderColor: '#ccc',
                                        borderRadius: '4px',
                                        height: '36px',
                                        width: '150px',
                                        backgroundColor: '#fff',
                                        textAlign: 'left',
                                        marginRight: 10
                                    }}
                                    dropdownStyle={{
                                        width: '200px',
                                    }}
                                />


                                    {/* <Select
                                    isSearchable={true}
                                            options={FlatList ? FlatList.map(item => ({ value: item.flatId, label: item.flatName })) : []}
                                            getOptionLabel={(option) => option.label}
                                        getOptionValue={(option) => option.value}
                                            className="sltareamodal"
                                            placeholder='Select Flat'
                                            values={
                                                FlatList && FlatIdSelect && FlatIdSelect.length > 0
                                                    ? FlatList.filter(item => item.flatId === FlatIdSelect[0]).map(item => ({ value: item.flatId, label: item.flatName }))
                                                    : []
                                            }
                                            onChange={(values) => {
                                                if (values && values.length > 0) {
                                                    setFlatIdSelect([parseInt(values[0].value), values[0].label]);
                                                } else {
                                                    setFlatIdSelect([]);
                                                }
                                            }}
                                            filterOption={(option, inputValue) =>
                                            option.label.toLowerCase().includes(inputValue.toLowerCase())
                                            }
                                                style={{
                                                    fontSize: '13px',
                                                    borderColor: '#ccc',
                                                    borderRadius: '4px',
                                                    height: '30px',
                                                    width: '150px',
                                                    backgroundColor: '#fff',
                                                    textAlign: 'left',
                                                }}
                                                dropdownStyle={{
                                                    width: '200px',
                                                }}
                                            /> */}

                                            <Select
                                                searchable={true}
                                                clearable={FlatIdSelect && FlatIdSelect.length > 0}
                                                options={FlatList ? FlatList.map(item => ({ value: item.flatId, label: item.flatName })) : []}
                                                labelField="label"
                                                valueField="value"
                                                className="sltareamodal"
                                                placeholder='Select Flat'
                                                values={
                                                    FlatList && FlatIdSelect && FlatIdSelect.length > 0
                                                        ? FlatList.filter(item => item.flatId === FlatIdSelect[0]).map(item => ({ value: item.flatId, label: item.flatName }))
                                                        : []
                                                }
                                                onChange={(values) => {
                                                    if (values && values.length > 0) {
                                                        setFlatIdSelect([parseInt(values[0].value), values[0].label]);
                                                    } else {
                                                        // setFlatIdSelect([]);
                                                    }
                                                }}
                                                searchBy="label"
                                                style={{
                                                    fontSize: '13px',
                                                    borderColor: '#ccc',
                                                    borderRadius: '4px',
                                                    height: '30px',
                                                    width: '150px',
                                                    backgroundColor: '#fff',
                                                    textAlign: 'left',
                                                }}
                                                dropdownStyle={{
                                                    width: '200px',
                                                }}
                                            />

                                    {/* <Select
                                        isSearchable={true}
                                        options={flatOptions}
                                        getOptionLabel={(option) => option.label}
                                        getOptionValue={(option) => option.value}
                                        className=""
                                        placeholder="Select Flat"
                                        values={
                                        FlatIdSelect && FlatIdSelect.length > 0
                                            ? flatOptions.filter(option => option.value == FlatIdSelect[0])
                                            : []
                                        }
                                        onChange={(selectedOptions) => {
                                        if (selectedOptions && selectedOptions.length > 0) {
                                            setFlatIdSelect([selectedOptions[0].value, selectedOptions[0].label]);
                                        } else {
                                            // setFlatIdSelect([]);
                                        }
                                        }}
                                        filterOption={(option, inputValue) =>
                                        option.label.toLowerCase().includes(inputValue.toLowerCase())
                                        }
                                        style={{
                                        fontSize: '13px',
                                        borderColor: '#ccc',
                                        borderRadius: '4px',
                                        height: '39px',
                                        width: '140px',
                                        backgroundColor: '#fff',
                                        textAlign: 'left',
                                        }}
                                        dropdownStyle={{
                                        width: '200px',
                                        }}
                                    /> */}
                                
                                {/* <Select
                                    options={FlatList ? FlatList.map(item => ({ id: item.flatId, name: item.flatName })) : []}
                                    labelField="name"
                                    className="sltareamodal"
                                    valueField="id"
                                    placeholder='Select Flat'
                                    values={
                                        FlatList && FlatIdSelect && FlatIdSelect.length > 0
                                            ? FlatList.filter(item => item.flatId === FlatIdSelect[0]).map(item => ({ id: item.flatId, name: item.flatName }))
                                            : []
                                    }
                                    onChange={(values) => {
                                        if (values && values.length > 0) {
                                            setFlatIdSelect([parseInt(values[0].id), values[0].name]);
                                        } else {
                                            setFlatIdSelect([]);
                                        }
                                    }}
                                    style={{
                                        fontSize: '13px',
                                        borderColor: '#ccc',
                                        borderRadius: '4px',
                                        height: '30px',
                                        width: '150px',
                                        backgroundColor: 'gainsboro',
                                        textAlign: 'left',
                                    }}
                                    dropdownStyle={{
                                        width: '200px',
                                    }}
                                /> */}
                            </div>
                            <button style={{ marginLeft: 5 }} type="button" className="btn btn-info" onClick={() =>
                                openCreateModal()}>
                                <FontAwesomeIcon icon={faPlus} />{" "}
                                Add Family Head
                            </button>
                        </div>
                    </div>




                    <Modal size="md" show={showFamily} onHide={() =>
                        setShowFamily(false)} className="modal-100w modal-md clientmodal right text-end p-0" aria-labelledby="contained-modal-title-vcenter ">
                        <Modal.Header closeButton className='headerMDL'>
                            <Modal.Title id="contained-modal-title-vcenter">
                                Family Transfer
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="helpingElelemnt_uuy002">

                            <div className="container">
                                <div className="card-no-border">
                                    <div className="row" id="validation">
                                        <div className="col-12">

                                            <div className="card-body p-0">

                                                <form action="#" className="validation-wizard wizard-circle wizard clearfix" role="application" id="steps-uid-2" novalidate="novalidate">

                                                    <div className="content clearfix">


                                                        <section id="steps-uid-2-p-0" role="tabpanel" aria-labelledby="steps-uid-2-h-0" className="body current pt-2" aria-hidden="false">
                                                            <div className="row text-left">




                                                                <div className="col-md-12 mb-2">
                                                                    <div className="form-group text-left mt-2">
                                                                        <label for="wfirstName2"> Tower  <span className="danger">*</span> </label>
                                                                        <select size="md" className="form-control required" onChange={(e) => {
                                                                            console.log("selection", e.target.value)
                                                                            setNewTowerSelect(e.target.value.split(","))
                                                                        }}>
                                                                            <option value={[]}>Select Tower</option>
                                                                            {TowerList ? TowerList.map((item, index) => <option key={index} value={[item?.towerId, item?.towerName]}>{item.towerName}</option>) : null}
                                                                        </select>

                                                                    </div>
                                                                    <div className="form-group text-left mt-2">
                                                                        <label for="wfirstName2"> New Flat Number  <span className="danger">*</span> </label>
                                                                        <select size="md" className="form-control required" value={NewFlatNumber} onChange={(e) => {
                                                                            console.log("selection", e.target.value)
                                                                            setNewFlatNumber(e.target.value.split(","))
                                                                        }}>
                                                                            <option value={[]}>Select Flat</option>
                                                                            {NewFlatListShow ? NewFlatListShow.map((item, index) => <option key={index} value={[item?.flatId, item?.flatName]}>{item.flatName}</option>) : null}
                                                                        </select>
                                                                    </div>
                                                                </div>

                                                            </div></section>
                                                    </div></form></div></div></div>
                                    {/* <button  onClick={ResidentUser} className='mt-2'>Submit  </button> */}
                                    {/* <div className="col-12">
                                <div className="card wizard-content">
                                    <div className="card-body">
                                        <form action="#" className="validation-wizard wizard-circle wizard clearfix" role="application" id="steps-uid-0" novalidate="novalidate">
                                            
                                            <div>
                                                <Stepper activeStep={activeStep}>
                                                    {steps.map((label) => ( 
                                                    <Step key={label}>
                                                        <StepLabel>{label}</StepLabel>
                                                    </Step>
                                                    ))} 
                                                </Stepper>
                                            </div>
                                            <div>
                                                {getStepContent(activeStep)} 
                                                <div>
                                                    <Button className="back_btn" disabled={activeStep===0} onClick={handleBack}> Back </Button>
                                                    <Button variant="contained" className="next_btn" onClick={handleNext}> {activeStep === steps.length - 1 ? 'Finish' : 'Next'} </Button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div> */}
                                </div>
                            </div>
                        </Modal.Body>

                        <div className="fixed_allbtn">
                            <div className="upload_btn">
                                <ul role="menu" aria-label="Pagination" className='mb-0'>
                                    <button type="button" className="btn border bg-white" onClick={() => setShowFamily(false)}> Cancel</button>
                                    <button type="button" className="btn btn-info" onClick={() => SubmitFamilyTransferModal()}> Submit</button>
                                </ul>
                            </div>
                        </div>


                    </Modal>
                    
                    <Modal show={show} onHide={() =>
                        setShow(false)} className="modal-100w modal-md clientmodal right text-end p-0" aria-labelledby="contained-modal-title-vcenter ">
                        <Modal.Header closeButton className='headerMDL'>
                            <Modal.Title id="example-custom-modal-styling-title"> Add Primary Resident </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="helpingElelemnt_uuy002">

                            <div className="row" id="validation">
                                <div className="col-md-12 mb-2">
                                    <div className="form-group text-left mt-2">
                                        <label for="wfirstName2"> Full Name  <span className="danger">*</span> </label>
                                        <input type="text" value={UserName} onChange={(e) => setUserName(e.target.value)} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" /> </div>
                                </div>
                                {/* <div className="col-md-12 mb-2">
                                <div className="form-group text-left mt-2">
                                    <label for="wfirstName2"> Full Name  <span className="danger">*</span> </label>
                                    <input type="text" value={FullName} onChange={(e) => setFullName(e.target.value)} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" /> </div>
                            </div> */}
                                <div className="col-md-12">
                                    <div className="form-group text-left mt-2">
                                        <label for="wlastName2"> Mobile Number  <span className="danger">*</span> </label>
                                        <input type="text" value={MobileNumber} onChange={(e) => setMobileNumber(e.target.value)} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" />
                                    </div>

                                </div>
                                <div className="col-md-12">
                                    <div className="form-group text-left mt-2">
                                        <label for="wlastName2"> Email </label>
                                        <input type="text" value={EmailId} onChange={(e) => setEmailId(e.target.value)} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" />
                                    </div>

                                </div>
                                <div className="col-md-12">
                                    <div className="form-group text-left mt-2">
                                        <label htmlFor="gender">Gender <span className="danger">*</span></label><br />
                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                            <input type="radio" id="Male" name="gender" value="Male" onChange={(e) => setGender(e.target.value)} />
                                            <label htmlFor="Male">Male</label><br />
                                            <input type="radio" id="Female" name="gender" value="Female" onChange={(e) => setGender(e.target.value)} />
                                            <label htmlFor="Female">Female</label><br />
                                            <input type="radio" id="Other" name="gender" value="Other" onChange={(e) => setGender(e.target.value)} />
                                            <label htmlFor="Transgender">Other</label><br />
                                        </div>
                                        {/* <input type="radio"  name="fav_language" value="Tenant" />
                                    <label for="javascript">JavaScript</label> */}

                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group text-left mt-2">
                                        <label for="fav_language"> Role <span className="danger">*</span> </label><br />
                                        <div style={{display: "flex", justifyContent: "space-evenly"}}>
                                            <input type="radio" id="Owner" name="fav_language" value="Owner" onChange={(e) => setRole(e.target.value)} />
                                            <label for="Owner">Owner</label><br />
                                            <input type="radio" id="Tenant" name="fav_language" value="Tenant" onChange={(e) => setRole(e.target.value)} />
                                            <label for="Tenant">Tenant</label><br />
                                        </div>    
                                        {/* <input type="radio"  name="fav_language" value="Tenant" />
                                    <label for="javascript">JavaScript</label> */}

                                    </div>
                                </div>

                                

                                {/* <button  onClick={ResidentUser} className='mt-2'>Submit  </button> */}
                                {/* <div className="col-12">
                                <div className="card wizard-content">
                                    <div className="card-body">
                                        <form action="#" className="validation-wizard wizard-circle wizard clearfix" role="application" id="steps-uid-0" novalidate="novalidate">
                                            
                                            <div>
                                                <Stepper activeStep={activeStep}>
                                                    {steps.map((label) => ( 
                                                    <Step key={label}>
                                                        <StepLabel>{label}</StepLabel>
                                                    </Step>
                                                    ))} 
                                                </Stepper>
                                            </div>
                                            <div>
                                                {getStepContent(activeStep)} 
                                                <div>
                                                    <Button className="back_btn" disabled={activeStep===0} onClick={handleBack}> Back </Button>
                                                    <Button variant="contained" className="next_btn" onClick={handleNext}> {activeStep === steps.length - 1 ? 'Finish' : 'Next'} </Button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div> */}
                            </div>

                        </Modal.Body>

                        <div className="fixed_allbtn">
                            <div className="upload_btn">
                                <ul role="menu" aria-label="Pagination" className='mb-0'>
                                    <button type="button" className="btn border bg-white" onClick={() => setShow(false)}> Cancel</button>
                                    <button type="button" className="btn btn-info" onClick={() => ResidentUser()}> Submit</button>
                                </ul>
                            </div>
                        </div>

                    </Modal>
                    <Modal centered show={DeleteShow} onHide={() =>
                        setDeleteShow(true)} dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
                        {/* <Modal.Header className="headerMDL" closeButton>
                    <Modal.Title id="contained-modal-title-vcenter" centered onClick={openCreateModal}>
                        <h4 className="mb-0"> Delete Vehicle </h4>
                    </Modal.Title>
                </Modal.Header> */}
                        <Modal.Body className='p-0' style={{ borderRadius: "10px", overflow: "hidden" }}>
                            <div className="row px-3" id="validation">
                                <div className="col-12 bg-white pt-3 pb-2">
                                    <div className="FnFItem" style={{ justifyContent: "flex-start" }}>
                                        {/* <div className="FnFimg">
                                <img src={stopMark} className='img img-fluid img-responsive'  alt="placeholder" />
                            </div> */}
                                        <div className="FnFtxt">
                                            <h2> Delete Vehicle </h2>
                                            <h3> Are you sure you want to delete? </h3>
                                        </div>
                                    </div>

                                </div>

                            </div>
                            <div className='confirmation_btn pb-4 pt-3 px-3' style={{ justifyContent: "center", borderTop: "1px solid #dadada" }}>
                                <div className='both_ConfrmBTN col-6'>
                                    <Button variant="danger">Delete</Button>{' '}
                                </div>
                                <div className='both_ConfrmBTN col-6' onClick={() => setDeleteShow(false)} >
                                    <Button variant="light"> Cancel</Button>{' '}
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>

                    <Modal centered show={FamilyTransferShow} onHide={() =>
                        setFamilyTransferShow(true)} dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
                        <Modal.Body className='p-0' style={{ borderRadius: "10px", overflow: "hidden" }}>
                            <div className="row px-3" id="validation">
                                <div className="col-12 bg-white pt-3 pb-2">
                                    <div className="FnFItem" style={{ justifyContent: "flex-start" }}>
                                        {/* <div className="FnFimg">
                                <img src={stopMark} className='img img-fluid img-responsive'  alt="placeholder" />
                            </div> */}
                                        <div className="FnFtxt">
                                            <h2> Family Transfer </h2>
                                            <h3> Are you sure you want to transfer the family from {OldTowerName}-{OldFlatName} to {NewTowerSelect[1]}-{NewFlatNumber[1]}?  </h3>
                                        </div>
                                    </div>

                                </div>

                            </div>
                            <div className='confirmation_btn pb-4 pt-3 px-3' style={{ justifyContent: "center", borderTop: "1px solid #dadada" }}>
                                <div className='both_ConfrmBTN col-6' onClick={FamilyTransferApi}>
                                    <Button variant="primary">Transfer</Button>{' '}
                                </div>
                                <div className='both_ConfrmBTN col-6' onClick={() => setFamilyTransferShow(false)} >
                                    <Button variant="light"> Cancel</Button>{' '}
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>

                    <Modal centered show={ErrorShow} onHide={() =>
                        setErrorShow(true)} dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
                        {/* <Modal.Header className="headerMDL" closeButton>
                    <Modal.Title id="contained-modal-title-vcenter" centered onClick={openCreateModal}>
                        <h4 className="mb-0"> Delete Vehicle </h4>
                    </Modal.Title>
                </Modal.Header> */}
                        <Modal.Body className='p-0' style={{ borderRadius: "10px", overflow: "hidden" }}>
                            <div className="row px-3" id="validation">
                                <div className="col-12 bg-white pt-3 pb-2">
                                    <div className="FnFItem" style={{ justifyContent: "flex-start" }}>
                                        {/* <div className="FnFimg">
                                <img src={stopMark} className='img img-fluid img-responsive'  alt="placeholder" />
                            </div> */}
                                        <div className="FnFtxt">
                                            <h2>{ErrorMessageHeader}</h2>
                                            <h3> {ErrorMessage[0]} </h3>
                                            <h3> {ErrorMessage[1]} </h3>
                                            <h3> {ErrorMessage[2]} </h3>
                                            {/* <h3> {ErrorMessage[1]} </h3>
                                <h3> {ErrorMessage[2]} </h3> */}
                                        </div>
                                    </div>

                                </div>

                            </div>
                            <div className='confirmation_btn pb-4 pt-3 px-3' style={{ justifyContent: "center", borderTop: "1px solid #dadada" }}>
                                {/* <div className='both_ConfrmBTN col-6'>
                                <Button variant="danger">Delete</Button>{' '}
                            </div> */}
                                <div className='both_ConfrmBTN col-6' onClick={() => setErrorShow(false)} >
                                    <Button variant="light"> Ok</Button>{' '}
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>

                    <Modal centered show={ModalWarningShow} onHide={() =>
                        setModalWarningShow(true)} dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
                        <Modal.Body className='p-0' style={{ borderRadius: "10px", overflow: "hidden" }}>
                            <div className="row px-3" id="validation">
                                <div className="col-12 bg-white pt-3 pb-2">
                                    <div className="FnFItem" style={{ justifyContent: "flex-start" }}>
                                        {TenantWarningShow ?
                                            <div className="FnFtxt">
                                                <h2>Warning</h2>
                                                <h3> A Tenant family is already residing in the flat, please delete existing family record to proceed further. </h3>
                                            </div>
                                            : null}
                                        {OwnerWarningShow ?
                                            <div className="FnFtxt">
                                                <h2>Warning</h2>
                                                <h3> An Owner family is already residing in the flat, please delete existing family record to proceed further. </h3>
                                            </div>
                                            : null}
                                        {InfoWarningShow ?
                                            <div className="FnFtxt">
                                                <h2>Warning</h2>
                                                <h3> A Family is already residing in the flat, please delete existing family record to proceed further. </h3>
                                            </div>
                                            : null}

                                    </div>

                                </div>

                            </div>
                            <div className='confirmation_btn pb-4 pt-3 px-3' style={{ justifyContent: "center", borderTop: "1px solid #dadada" }}>
                                {/* <div className='both_ConfrmBTN col-6'>
                                <Button variant="danger">Delete</Button>{' '}
                            </div> */}
                                <div className='both_ConfrmBTN col-6' onClick={() => setModalWarningShow(false)} >
                                    <Button variant="light"> Ok</Button>{' '}
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>


                    <Modal centered show={ChildDeleteModal} onHide={() =>
                        setChildDeleteModal(false)} dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
                        <Modal.Body className='p-0' style={{ borderRadius: "10px", overflow: "hidden" }}>
                            <div className="row px-3" id="validation">
                                <div className="col-12 bg-white pt-3 pb-2">
                                    <div className="FnFItem" style={{ justifyContent: "flex-start" }}>
                                        <div className="FnFtxt">
                                            <h2> Delete {CheckPosition}</h2>
                                            <h3> Are you sure you want to delete? </h3>
                                        </div>
                                    </div>

                                </div>

                            </div>
                            <div className='confirmation_btn pb-4 pt-3 px-3' style={{ justifyContent: "center", borderTop: "1px solid #dadada" }}>
                                <div className='both_ConfrmBTN col-6' onClick={DeleteChildUser}>
                                    <Button variant="danger">Delete</Button>{' '}
                                </div>
                                <div className='both_ConfrmBTN col-6' onClick={() => setChildDeleteModal(false)} >
                                    <Button variant="light"> Cancel</Button>{' '}
                                </div>
                            </div>
                        </Modal.Body>

                    </Modal>
                    <div className="row">
                        <div className="col-12">
                         
                                    
                                        {!ParentUpdate ?
                                        <div className='bg-white' style={{ paddingBottom:"50px",borderRadius: "10px" }}>
                                            <div className='col-12 text-center pb-3'>
                                                <img src={ResidentInital} alt="user" style={{ height: "100px" }} className="mx-auto mt-5" />
                                            </div>
                                            <br />
                                            {/* <h3 className='col-12 text-center NoDataShowTextColor' style={{ marginTop: "0px" }}> Select a Flat to Manage Residents</h3> */}
                                            <h5 className='col-12 text-center NoDataShowTextColor' style={{ marginTop: "10px" }}> Select a Flat to Manage Residents</h5>
                                        </div>

                                        : null}
                                            <div className='row'>
                                                <div className="col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
                                                    

                                                    {NoResidentData ?
                                                    <>
                                                            <div className='bg-white' style={{ paddingBottom:"50px",borderRadius: "10px" }}>
                                                                <div className='col-12 text-center pb-3'>
                                                                    <img src={NoResiding} alt="user" style={{ height: "100px" }} className="mx-auto mt-5" />
                                                                </div>
                                                                <br />
                                                                <h3 className='col-12 text-center NoDataShowTextColor' style={{ marginTop: "0px" }}> No primary user found</h3>
                                                                {/* <h5 className='col-12 text-center NoDataShowTextColor' style={{ marginTop: "10px" }}> Select a Flat to Manage Residents</h5> */}
                                                            </div>             
                                                        </>

                                                    : null}    


                                                    {ParentUpdate ? ParentUpdate.map((item, index) => <>
                                                        {item?.isParent == true ?
                                                            <div key={index} className="col-lg-9 col-md-9 col-sm-12 col-12 mb-4">
                                                                <div className="card card-body bg-white boxshdw">
                                                                    <div className="row">
                                                                        {/* <FontAwesomeIcon className="deleteResident"  icon={faTrash} /> */}
                                                                        <div className="col-md-6 col-lg-5 text-center">
                                                                            {item?.isResiding ?
                                                                                <div className="ex_feild"> <img src={ResidingTag} className='img img-fluid' /></div>
                                                                                : null}
                                                                            <a>
                                                                                {item?.userImage ?
                                                                                    <div className='residentmain__floatimg'>
                                                                                        <img src={item?.userImage} alt="user" className="img-circle img-responsive" />
                                                                                    </div>
                                                                                    :
                                                                                    <div className="user_alphabet">
                                                                                        <h3 style={{ textTransform: "capitalize" }}>{item.userName[0]} </h3>
                                                                                    </div>
                                                                                }

                                                                            </a>
                                                                        </div>
                                                                        <div className="col-md-6 col-lg-7 padding-none">
                                                                            <h2 className="box-title mb-0"> {item?.userName}</h2>
                                                                            <h5 className='text-black'>{item?.roleName} </h5>
                                                                            {/* <img src={approvaltick} alt="user" className="apptick" />  */}
                                                                            <h6> Tower Name : {item?.towerName} </h6>
                                                                            <h6> Flat Number : {item?.flatName} </h6>

                                                                            {/* <h6> Currently Residing : {item?.roleName} </h6> */}
                                                                            {item?.roleName.toUpperCase() == "OWNER" ?
                                                                                <div className='row'> <h6 className='col-7 pt-1 pr-0'>Currently Residing :</h6>
                                                                                    <label className="switch1" style={{marginLeft: "-12px"}}>
                                                                                        <input type="checkbox" checked={item?.isResiding} onChange={() => SelectResiding(item)} />
                                                                                        <span className="slider1 round1" key={index}></span>
                                                                                    </label>
                                                                                </div>
                                                                                :
                                                                                <div className='row'> <h6 className='col-7 pt-1 pr-0'>Currently Residing :</h6>
                                                                                    <h6 className='col-5 pl-0 pt-1' style={{marginLeft: "-12px"}}> Yes </h6>
                                                                                    {/* <label className="switch1 ml-1" >
                                                                            <input type="checkbox" checked={item?.isResiding} onChange={() => DeleteUserModal(item)}/>
                                                                            <span className="slider1 round1" key={index}></span>
                                                                        </label> */}
                                                                                </div>
                                                                            }

                                                                        </div>
                                                                    </div>

                                                                    <div className='row mt-2'>
                                                                        <div className="col-lg-4 col-md-4 col-sm-4 col-4">
                                                                            <Link className='residentLinks' to={"/Familydetails"} state={[{ item: item, familyGroupId: item?.familyGroupId, userName: item?.userName, Email: item?.emailId, Address1: item?.addressLine1, Address2: item?.addressLine2, MobileNumber: item?.mobileNumber }]} onClick={handleViewMore}>View More</Link>

                                                                        </div>

                                                                        <div className="col-lg-5 col-md-5 col-sm-4 col-5">
                                                                        {item?.roleName.toUpperCase() == "TENANT" ?
                                                                            <Link className='residentLinks' onClick={() => FamilyTransferModal(item)}>Family Transfer</Link>
                                                                            :null}
                                                                        </div>
                                                                        <div className="col-lg-3 col-md-3 col-sm-4 col-3">

                                                                            <Link className='residentLinks' onClick={() => DeleteUserModal(item)} >Delete</Link>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        :null }    
                                                    </>) : 
                                                        null
                                                    }
                                                </div>   
                                                <div className="col-lg-6 col-md-6 col-sm-12 col-12 mb-4 px-0"> 
                                                    {PendingTable ?
                                                        <div className=''>
                                                            <div className='col-12 px-0'>
                                                            <h5 className="card-title b mt-0 align-self-center">Pending Users{" "}</h5>
                                                                <div className="listvisitor" style={{height: 180}}>
                                                                    <Table ordered hover className="tableFixHeadDash">
                                                                        <thead > 
                                                                            <tr>
                                                                                <th style={{width: 180}}>User Name</th> 
                                                                                <th style={{width: 180}}>Mobile#</th>
                                                                                <th style={{width: 180}}>Resident Type</th>
                                                                            </tr>
                                                                
                                                                        </thead>
                                                                        <tbody>
                                                                            {ParentPending ? ParentPending.map((item, index) => <>
                                                                                {item?.currentStatus.toUpperCase() == "PENDING" ?
                                                                                    <tr>
                                                                                        <td className="dashtabletext"> {item?.userName} </td>
                                                                                        <td>{item?.mobileNumber}</td>
                                                                                        <td> {item?.roleName} </td>  
                                                                                    </tr> 
                                                                                :null}  

                                                                            </>) : null} 
                                                                            {NoTableData ?
                                                                            <div>
                                                                                <h6 className="dashtabletext nodataText"> No data found </h6>
                                                                            </div>
                                                                            :null}
                                                                        </tbody> 
                                                                    </Table>    
                                                                </div>
                                                            </div>   
                                                            <div className='col-12 px-0'>
                                                            <h5 className="card-title b mt-4 align-self-center">Pending Vehicles{" "}</h5>    
                                                                <div className="listvisitor" style={{height: 180}}>
                                                                    <Table ordered hover className="tableFixHeadDash">

                                                                        <thead > 

                                                                                
                                                                            <tr>
                                                                                <th style={{width: 180}}>Owner Name</th> 
                                                                                <th style={{width: 180}}>Vehicle #</th>
                                                                                <th style={{width: 180}}>Vehicle Type</th>  
                                                                            </tr>
                                                                
                                                                        </thead>
                                                                        <tbody>
                                                                            {VehiclePendingList ? VehiclePendingList.map((item, index) => <>
                                                                                {item?.currentStatus.toUpperCase() == "PENDING" ?
                                                                                    <tr>
                                                                                        <td className="dashtabletext"> {item?.ownerName} </td>
                                                                                        <td>{item?.lpNumber}</td>
                                                                                        <td> {item?.vehicleType} </td>  
                                                                                    </tr> 
                                                                                :null}  

                                                                            </>) : null}
                                                                        
                                                                            {NoVehicleTableData ?
                                                                                <div>
                                                                                    <h6 className="dashtabletext nodataText"> No data found </h6>
                                                                                </div>
                                                                            :null}
                                                                           
                                                                        </tbody> 
                                                                        
                                                                    </Table>    
                                                                </div>
                                                            </div>   
                                                        </div>     
                                                    :null}  
                                                </div>      

                                            </div>
                                            <br />

                                      
                                    
                          
                        </div>
                    </div>
                </div>
            </section>
        </>)

}

export default Resident